import { PaymentMethod } from '../../../../core/reducers/financialCalculators';
import { CUSTOMER_CASH_REBATE_NAME } from '../../../../utils/constants';
import buildPaymentTab from './buildPaymentTab';
import getFallbackPaymentTab from './getFallbackPaymentTab';
import parseTemplateCtaLink from './parseTemplateCtaLink';
const paymentMethodTabTypeRecord = {
    [PaymentMethod.cash]: 'rebate',
    [PaymentMethod.finance]: 'finance',
    [PaymentMethod.lease]: 'lease',
};
function convertTrimsDataToCardProps(config, trimsWithPaymentAndOffers, primaryCta, secondaryCta) {
    const cards = trimsWithPaymentAndOffers.map(({ modelName, modelYear, trimName, modelLogo, modelKey, trimKey, transmissionKey, exteriorColorKey, interiorColorKey, offers, image: { width, height, alt, src }, financials: { defaultPaymentMethod }, payment, exploreModelCta, }) => {
        var _a, _b, _c;
        const { preferredPaymentAmount, sellingPrice } = payment || {};
        const { validPaymentTabs, fallbackPaymentFrequency } = config;
        const apr = (payment === null || payment === void 0 ? void 0 : payment.apr) || 0;
        const term = (payment === null || payment === void 0 ? void 0 : payment.term) || 0;
        const paymentAmount = preferredPaymentAmount || 0;
        const paymentFrequency = ((payment === null || payment === void 0 ? void 0 : payment.paymentFrequency) || fallbackPaymentFrequency);
        const cashRebate = (_c = (_b = (_a = offers === null || offers === void 0 ? void 0 : offers.incentiveOffers) === null || _a === void 0 ? void 0 : _a.cash) === null || _b === void 0 ? void 0 : _b.find(({ name }) => name === CUSTOMER_CASH_REBATE_NAME)) === null || _c === void 0 ? void 0 : _c.value;
        const paymentTabsRecord = Object.fromEntries(validPaymentTabs.map(tab => [
            tab,
            buildPaymentTab(tab, offers, cashRebate, apr, term, paymentAmount, paymentFrequency),
        ]));
        const paymentTabs = validPaymentTabs.map(tabType => paymentTabsRecord[tabType]).filter(tab => !!tab);
        const ctaTemplateDictionary = {
            modelKey,
            trimKey,
            transmissionKey,
            modelYear,
            exteriorColorKey,
            interiorColorKey,
        };
        const cta1 = parseTemplateCtaLink(primaryCta, ctaTemplateDictionary);
        const cta2 = parseTemplateCtaLink(secondaryCta, ctaTemplateDictionary);
        const fallBackPaymentTab = getFallbackPaymentTab(offers, validPaymentTabs);
        return {
            modelInformation: {
                modelName,
                modelYear,
                trimName,
                modelLogo,
                modelKey,
                trimKey,
                transmissionKey,
                exteriorColorKey,
                interiorColorKey,
            },
            sellingPrice: {
                sellingPrice: (sellingPrice === null || sellingPrice === void 0 ? void 0 : sellingPrice.value) || 0,
                discount: 0, // Todo: get more info for this
            },
            ctas: [cta1, cta2, ...(exploreModelCta ? [exploreModelCta] : [])],
            modelImage: {
                height,
                width,
                alt,
                src,
            },
            paymentTabs,
            defaultPaymentTab: !defaultPaymentMethod
                ? fallBackPaymentTab
                : paymentMethodTabTypeRecord[defaultPaymentMethod],
            hasLoyaltyOffer: false, // TODO: disable loyalty offer for now, https://hondaca.atlassian.net/browse/APT-261
        };
    });
    return cards;
}
export default convertTrimsDataToCardProps;
